export default "__VITE_ASSET__DuFPEfee__"